<div class="vid-apskaita-forma-style" *ngIf="!sharedDataService.getKlaidos()">
  <label class="title">{{ 'title.gii.apskaita' | translate }}</label>
  <div class="col filter-box-style">
    <div class="row">
      <div class="col">
        <kendo-label [for]="dokumentoTipas" text="{{ 'apskaita.dokumentoTipas' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #dokumentoTipas
            fillMode="none"
            class="transparent-background"
            [data]="dokumentoTipasList"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.dokumentoTipas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="busena" text="{{'apskaita.busena' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #busena
            fillMode="none"
            class="transparent-background"
            [data]="busenosList"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.busena">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="vidineBusena" text="{{'apskaita.vidineBusena' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #vidineBusena
            fillMode="none"
            class="transparent-background"
            [data]="vidinesBusenosList"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.vidineBusena">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <kendo-label [for]="metai" text="{{ 'apskaita.metai' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #metai
            fillMode="none"
            class="transparent-background"
            [data]="years"
            [(ngModel)]="apskaitaFilter.metai">
          required>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="subjektoTipas" text="{{ 'apskaita.subjektoTipas' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #subjektoTipas
            fillMode="none"
            class="transparent-background"
            [data]="subjektoTipasList"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.subjektoTipas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="subjektas" text="{{ 'apskaita.subjektas' | translate }}"></kendo-label>
        <kendo-textbox
            #subjektas
            [clearButton]="true"
            [(ngModel)]="apskaitaFilter.subjektas"
        ></kendo-textbox>
      </div>
    </div>
    <div class="row" style="padding-top: 10px">
      <div class="col">
        <kendo-label [for]="atsakomybesBudas" text="{{ 'apskaita.atsakomybesBudas' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #atsakomybesBudas
            fillMode="none"
            class="transparent-background"
            [data]="atsakomybesBudasList"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.atsakomybesBudas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="orderBy" text="{{ 'apskaita.rikiuotiPagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #orderBy
            fillMode="none"
            class="transparent-background"
            [textField]="'text'"
            [valueField]="'value'"
            [data]="orderByList"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.orderBy"
            (ngModelChange)="filterOrderBy2(apskaitaFilter.orderBy, apskaitaFilter.orderByThird)">
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="orderBySecond" text="{{ 'apskaita.rikiuotiTadaPagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #orderBySecond
            fillMode="none"
            class="transparent-background"
            [textField]="'text'"
            [valueField]="'value'"
            [data]="orderByListSecond"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.orderBySecond"
            (ngModelChange)="filterOrderBy3(apskaitaFilter.orderBy, apskaitaFilter.orderBySecond)">
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row" style="padding-top: 10px">
      <div class="col">
        <kendo-label [for]="orderByThird" text="{{ 'apskaita.rikiuotiTadaPagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #orderByThird
            fillMode="none"
            class="transparent-background"
            [textField]="'text'"
            [valueField]="'value'"
            [data]="orderByListThird"
            [valuePrimitive]="true"
            [(ngModel)]="apskaitaFilter.orderByThird">
        </kendo-dropdownlist>
      </div>
    </div>
    <div style="float: right;">
      <kendo-button class="filter-button" kendoButton themeColor="primary" fillMode="outline" style="margin-right: 10px" (click)="openExportDialog()">
        {{ 'button.eksportuoti.duomenis' | translate }}
      </kendo-button>
      <kendo-button class="filter-button" kendoButton themeColor="primary" fillMode="outline" (click)="onFilterClicked()">
        {{ 'button.filtruoti' | translate }}
      </kendo-button>
    </div>
  </div>
  <div class="col">
    <div>
      <kendo-grid #giiApskaitaGrid
                  [data]="view | async"
                  [selectable]="true"
                  (cellClick)="onRowSelect($event.dataItem)"
                  [class]="'selectable-grid'"
                  [loading]="giiAtaskaitaService.loading"
                  [pageable]="{
                      pageSizes: [20, 50, 100]
                      }"
                  [pageSize]="pageSize"
                  [skip]="state.skip"
                  (pageChange)="onPageChanged($event)">
        <kendo-grid-column field="dokumentoTipas" title="{{ 'apskaita.dokumentoTipas' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ ('enum.dokumentoTipas.' + dataItem.dokumentoTipas) | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="busena" title="{{ 'apskaita.busena' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ ('enum.ataskaitosBusena.' + dataItem.busena) | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="vidineBusena" title="{{ 'apskaita.vidineBusena' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ ('enum.vidineAtaskaitosBusena.' + dataItem.vidineBusena) | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="busenosData" title="{{ 'apskaita.busenosData' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.busenosData | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="ataskLaikotarpis" title="{{ 'apskaita.metai' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-column field="subjektoKodas" title="{{ 'apskaita.subjektoKodas' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-column field="subjektoPavadinimas" title="{{ 'apskaita.subjektoPavadinimas' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-column field="subjektoTipas" title="{{ 'apskaita.subjektoTipas' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ ('label.tipas.' + dataItem.subjektoTipas) | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="registracijosData" title="{{ 'apskaita.registracijosData' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.registracijosData | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="atsakomybesBudas" title="{{ 'apskaita.atsakomybesBudas' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.atsakPavadinimas | translateName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="isregistravimoData" title="{{ 'apskaita.isregistravimoData' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.isregistravimoData | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-messages
                [pagerItemsPerPage]="'label.irasai.puslapyje' | translate"
                [pagerItems]="'label.irasu' | translate"
                [pagerOf]="'label.is' | translate"
                [pagerPage]="'label.puslapis' | translate"
                [noRecords]="'label.sarasas.tuscias' | translate">
        </kendo-grid-messages>
      </kendo-grid>
    </div>
  </div>
  <kendo-window
    *ngIf="this.showExportDialog"
    (close)="this.closeExportDialog()"
    [minWidth]="250"
    [width]="650"
    themeColor="primary"
    title="{{ 'title.duomenu.eksportas' | translate }}"
  >
    <div>
      <kendo-label [for]="ataskaitosPasirinkimas" text="{{ 'label.pasirinkti.ataskaita' | translate }}"></kendo-label>
      <kendo-dropdownlist
        #ataskaitosPasirinkimas
        fillMode="none"
        class="transparent-background"
        [data]="reports"
        [textField]="'name'"
        [valueField]="'id'"
        [value]="1"
        [valuePrimitive]="true"
      >
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          {{ dataItem.name | translate }}
        </ng-template>

        <ng-template kendoDropDownListValueTemplate let-dataItem>
          {{ dataItem?.name | translate }}
        </ng-template>
      </kendo-dropdownlist>
    </div>
    <div *ngIf="ataskaitosPasirinkimas.value == 1">
      <div class="mt-3">
        <kendo-label [for]="ataskMetai" text="{{ 'apskaita.ataskMetai' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #ataskMetai
          fillMode="none"
          [data]="years"
          [(ngModel)]="ataskaitosParametrai.ataskMetai"
        ></kendo-dropdownlist>
      </div>
    </div>
    <div *ngIf="ataskaitosPasirinkimas.value == 2">
      <div class="mt-3">
        <kendo-label [for]="ataskMetai" text="{{ 'apskaita.ataskMetai' | translate }}"></kendo-label>
        <kendo-dropdownlist
            #ataskMetai
            fillMode="none"
            [data]="years"
            [(ngModel)]="ataskaitosParametrai.ataskMetai"
        ></kendo-dropdownlist>
      </div>
      <div class="mt-3">
        <kendo-label [for]="giiKodas" text="{{ 'apskaita.giiKodas' | translate }}"></kendo-label>
        <kendo-textbox
            #giiKodas
            [clearButton]="true"
            [(ngModel)]="ataskaitosParametrai.giiKodas"
        ></kendo-textbox>
      </div>
    </div>
    <div class="k-form-buttons" style="padding-top: 20px">
      <div style="flex-grow: 1;"></div>
      <div style="float: right;">
        <kendo-button kendoButton themeColor="error" fillMode="outline" style="margin-right: 10px;" (click)="closeExportDialog()">
          {{ 'button.atsaukti' | translate }}
        </kendo-button>
        <gii-reports [ataskaitosParametrai]="ataskaitosParametrai" [ataskId]="ataskaitosPasirinkimas.value"></gii-reports>
      </div>
    </div>
  </kendo-window>
</div>
<div *ngIf="sharedDataService.getKlaidos()" class="error-message-red">
  {{ this.sharedDataService.getKlaidos() | translate}}
</div>
